/*
 * sT3r
 */
$(document).ready(function() {
  // OP kein plan was das hier bringt ist aus der alten sT3r
  jQuery("a[class*=lightbox]").each(function(index, link) {
    if(link.href.split('#')[0] === (window.location.origin + window.location.pathname)) {
      link.href = "#" + link.href.split('#')[1];
    }
  });
  //Fancybox init für die ganze Webseite
  $('[data-fancybox="*"]').fancybox({
    // Options will go here
  });

  //Standard to top link animation
  $('.top-link').on('click',function () {
    $('body,html').animate({
      scrollTop: 0
    }, 800);
  })

  $('.scroll-push').on('click',function () {
    $('body,html').animate({
      scrollTop: $('.content-main').first().offset().top
    }, 800);
  })

  //Mobi menu
  $('body .hamburger').on('click',function () {
    $('body').toggleClass('mobi-menu-open')
    $(this).toggleClass('is-active')
  })

  $('.fact-wrapper').equalHeight({
    cols : '.fact',
    target : ['.header'],
  })


  initSlider()
  initZeitplan()

  if($('#c55').length > 0){
    $('#c55').find('a.bs4 h3').text('Die verkehrliche Situation ist durch den Pendler- und Lieferverkehr auf der Strecke Neuenfelder und Cranzer Hauptdeich – sowie nach Hamburg allgemein – bereits sehr angespannt. Oft entstehen in Cranz und Neuenfelde lange Staus. Wie kann der Verkehrsfluss durch das Vorhaben optimiert werden? ');
  }
});

$(window).on('load',function () {
  $('#c12').equalHeight({
    cols : '.grid-col',
    target : ['.image'],
  })
});

function initZeitplan() {
  if($('.time-arrow').length > 0){

    if(window.matchMedia("(min-width: 992px)").matches) {
      zeitplanDesktop()
    }else {
      //start mobile stuff
      zeitplanMobile()
    }

    $(window).on('resize',function () {
      if(window.matchMedia("(min-width: 992px)").matches){
        zeitplanDesktop()
      }else{
        //start mobile stuff
        zeitplanMobile()
      }
    });

    function zeitplanDesktop() {
      var timeparts = $('.time-arrow .time-part');
      timeparts.off('click.timeparts');
      timeparts.on('click.timeparts', function () {
        timeparts.removeClass('act');
        $('.frame-type-mask_zeitplan .text-box .text').slideUp().removeClass('act');
        $(this).addClass('act');
        $('.frame-type-mask_zeitplan .text-box').find('.'+$(this).data('text')).slideDown(400,function () {
          $(this).addClass('act')
        });
      })
    }

    function zeitplanMobile() {
      var timeparts = $('.time-arrow .time-part');
      timeparts.off('click.timeparts');
      timeparts.on('click.timeparts', function () {
        $(this).toggleClass('open');
        if($(this).hasClass('open')){
          var text = $('.frame-type-mask_zeitplan .text-box').find('.'+$(this).data('text')).html();
          $(this).find('.mobile-text').html(text).slideDown();
        }else{
          //close
          $(this).find('.mobile-text').slideUp();
        }
      })
    }
  }
}

function initSlider() {
  var slider = false;
  if(window.matchMedia("(max-width: 992px)").matches){
    start();
  }else{
    stop();
  }

  $(window).on('resize',function () {
    if(window.matchMedia("(max-width: 992px)").matches){
      start();
    }else{
      stop();
    }
  });

  function start() {
    if(slider === false){
      $(document).ready(function(){
        slider = $('.fact-wrapper').slick({
            adaptiveHeight: true,
            prevArrow:'<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 9.8 16.6"><polyline points="8.3 15.1 1.5 8.3 8.3 1.5" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="3"/></svg></button>',
            nextArrow:'<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 9.8 16.6"><polyline points="1.5 1.5 8.3 8.3 1.5 15.1" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="3"/></svg></button>'
        });
      });
    }
  }

  function stop() {
    if(slider){
      slider.slick('unslick');
      slider = false;
    }
  }
}

///Smoothscroll also with page change, jumps to top and scrolls down

// to top right away
if ( window.location.hash ) scroll(0,0);
// void some browsers issue
setTimeout( function() {
  scroll(0,0);

  setTimeout(function () {
    if(window.location.hash) {
      // smooth scroll to the anchor id
      $('html, body').animate({
        scrollTop: $(window.location.hash).offset().top + 'px'
      }, 500);
    }
  },50);
}, 50);

/*
$(document).on('scrollUp',function(){ //define a custom event listener
  $('.hamburger').removeClass('down');

});

$(document).on('scrollDown',function(){ //define a custom event listener
  $('.hamburger').addClass('down');

});
*/

//smoothscroll for links with hash
$(function() {
  //@fixme avoid to kill standard bs4 functionality like collapse elements
  $("a:not(.bs4)").on('click', function(event) {
    // Make sure this.hash has a value before overriding default behavior
    if (this.hash !== "") {
      // Store hash
      var hash = this.hash;
      // Using jQuery's animate() method to add smooth page scroll
      // The optional number (800) specifies the number of milliseconds it takes to scroll to the specified area
      $('html, body').animate({
        scrollTop: $(hash).offset().top
      }, 500, function() {
        // Add hash (#) to URL when done scrolling (default click behavior)
        window.location.hash = hash;
      });
      return false;
    } // End if
  });

});


(function($) {
  $.fn.equalHeight = function(options) {
    var settings = $.extend({
      context : this,
      cols : '[class^=col-]',
      target : [],
      resize : true
    }, options);

    function makeHeightEqual() {
      var colArray = settings.context.find(settings.cols);

      while(colArray.length > 0) {

        // find all elements in a row
        var rowPosTop = colArray.eq(0).offset().top;
        var colsInCurrentRow = [];
        var i = 0;
        for(; i < colArray.length; i++) {
          if(colArray.eq(i).offset().top > rowPosTop) break;
        }
        // split colSet in current and rest
        if(colsInCurrentRow.length == 0) {
          colsInCurrentRow = colArray.slice(0, i);
          colArray = colArray.slice(i);
        }

        for(var ti = 0; ti < settings.target.length; ti++) {
          var targetSelector = settings.target[ti];
          // get max height of target element in current row
          var maxHeight = 0;
          for(var i = 0; i < colsInCurrentRow.length; i++) {
            var currentTarget = colsInCurrentRow.eq(i).find(targetSelector).first();
            // currentTarget.outerHeight() is int so we use [0].getBoundingClientRect().height;
            if(currentTarget.length > 0){
              // reset min-height regarding the resize function
              currentTarget.css('min-height', 0);
              var tempHeight = currentTarget[0].getBoundingClientRect().height;
              if(tempHeight > maxHeight) maxHeight = tempHeight+1;
            }
          }
          var ua = window.navigator.userAgent;
          var msie = ua.indexOf("MSIE ");
          // set all target elements to maxHeight
          for(var i = 0; i < colsInCurrentRow.length; i++) {

            if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./))  // If Internet Explorer, return version number
            {
              //set strict height for flex colum/justifiy content support
              colsInCurrentRow.eq(i).find(targetSelector).first().css('height', parseInt(maxHeight));
            }else{
              colsInCurrentRow.eq(i).find(targetSelector).first().css('min-height', parseInt(maxHeight));
            }
          }
        }
      }
    }

    if(settings.target.length < 1) return this;

    makeHeightEqual();

    if(settings.resize) {
      $(window).resize(function() {
        $(this).equalHeight($.extend(settings, {resize : false}));
      });
    }

    return this
  }
}(jQuery))
